module.exports = __webpack_public_path__ + "static/media/user-default-log.4895f89f.svg";